import { Event, EventType } from "./Event";

import type { IAddSearchEvent } from "./types";

export class AddSearchEvent extends Event {
  constructor({
    searchQuery,
    tracking,
    customEventProperties,
  }: IAddSearchEvent) {
    super({
      event_type: EventType.search,
      event_properties: { search_query: searchQuery, tracking },
      custom_event_properties: customEventProperties,
    });
  }
}
